/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterMSmall = createReactComponent("letter-m-small", "IconLetterMSmall", [
  ["path", { d: "M9 16v-8l3 5l3 -5v8", key: "svg-0" }]
]);

export { IconLetterMSmall as default };
//# sourceMappingURL=IconLetterMSmall.js.map
